import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Zap, ArrowUpRight, ArrowRight } from "lucide-react";
import api from "../lib/api";
import Reveal from "../components/Reveal";

export default function DealsPage() {
  const [deals, setDeals] = useState(null);

  useEffect(() => {
    api.get("/deals").then((r) => setDeals(r.data)).catch(() => setDeals([]));
  }, []);

  const track = (deal) =>
    api.post("/track/click", { url: deal.url, product: deal.product, article_slug: deal.article_slug }).catch(() => {});

  return (
    <div data-testid="deals-page" className="max-w-[1100px] mx-auto px-5 lg:px-10 py-16 lg:py-24">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4">The Vault</p>
        <h1 className="font-display font-black uppercase text-4xl sm:text-6xl tracking-tight break-words">
          Past deals, <span className="font-serif italic normal-case text-ash">still live</span>
        </h1>
        <p className="text-ash mt-5 max-w-xl leading-relaxed">
          Every Deal of the Day the desk has ever pinned. The picks stay vouched, the links stay live —
          if you missed one, it's here.
        </p>
      </Reveal>

      {!deals ? (
        <p className="font-mono text-ash text-xs uppercase tracking-[0.3em] py-24 text-center animate-pulse">Opening the vault…</p>
      ) : deals.length === 0 ? (
        <div className="border border-dashed border-white/15 py-24 text-center mt-14">
          <Zap size={26} className="text-ash mx-auto mb-4" />
          <p className="font-mono text-ash text-xs uppercase tracking-[0.3em]">The vault is empty — the first deal lands with tomorrow's issue.</p>
        </div>
      ) : (
        <div className="mt-14 border-t border-white/10">
          {deals.map((d, i) => (
            <Reveal key={d.id} delay={Math.min(i, 6) * 0.05}>
              <div data-testid="deal-vault-row"
                className="group flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8 py-7 border-b border-white/10 hover:bg-white/[0.02] transition-colors">
                <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-ash shrink-0 lg:w-28">
                  {format(new Date(d.created_at), "dd MMM yyyy")}
                </span>
                <div className="min-w-0 flex-1">
                  <a href={d.url} target="_blank" rel="noopener noreferrer sponsored" onClick={() => track(d)}
                    data-testid={`deal-vault-product-${i}`}
                    className="font-display font-extrabold text-xl sm:text-2xl text-porcelain group-hover:text-kinetic transition-colors underline decoration-kinetic/30 underline-offset-4 break-words">
                    {d.product}
                  </a>
                  <p className="text-ash text-sm mt-1.5">
                    From the story:{" "}
                    <Link to={`/article/${d.article_slug}`} className="text-porcelain/80 hover:text-kinetic transition-colors">
                      {d.article_title}
                    </Link>
                  </p>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <Link to={`/article/${d.article_slug}`} data-testid={`deal-vault-read-${i}`}
                    className="border border-white/15 hover:border-kinetic/60 text-porcelain font-mono text-[11px] uppercase tracking-[0.18em] px-5 py-3 rounded-full flex items-center gap-2 transition-colors duration-300">
                    Read <ArrowRight size={13} className="text-kinetic" />
                  </Link>
                  <a href={d.url} target="_blank" rel="noopener noreferrer sponsored" onClick={() => track(d)}
                    data-testid={`deal-vault-amazon-${i}`}
                    className="bg-kinetic text-obsidian font-mono text-[11px] uppercase tracking-[0.18em] font-medium px-5 py-3 rounded-full flex items-center gap-2 hover:bg-porcelain transition-colors duration-300">
                    Amazon <ArrowUpRight size={13} />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
